import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FullscreenLoading from "../../Prescription/Components/FullScreenLoader";

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const teleconsultId = searchParams.get("teleconsult_id");
  const encToken = searchParams.get("enc_token");

  useEffect(() => {
    if (!teleconsultId || !encToken) {
      alert("Data tidak lengkap");
      navigate("/home");
      return;
    }

    localStorage.removeItem('teleconsult_disclaimer');

    navigate(`/connect-doctor/${teleconsultId}/${encToken}`);
  }, [teleconsultId, encToken, navigate]);

  return <FullscreenLoading />;
};

export default PaymentSuccess;